import * as React from "react";

const ShopIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    viewBox="0 0 21 20"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M16.333 15.827c0 .46-.373.834-.833.834h-10a.834.834 0 0 1-.833-.834V6.661h1.666v.833a.833.833 0 1 0 1.667 0v-.833h5v.833a.833.833 0 1 0 1.667 0v-.833h1.666zM10.5 2.988c1.21 0 2.22.864 2.45 2.006h-4.9a2.504 2.504 0 0 1 2.45-2.006m6.667 2.006h-2.55c-.248-2.062-1.989-3.672-4.117-3.672s-3.87 1.61-4.117 3.672h-2.55A.833.833 0 0 0 3 5.827v10c0 1.379 1.122 2.5 2.5 2.5h10c1.378 0 2.5-1.121 2.5-2.5v-10a.833.833 0 0 0-.833-.833"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default ShopIcon;
